// extracted by mini-css-extract-plugin
export var container = "styles-module--container--02ec9";
export var originalPrice = "styles-module--originalPrice--3933d";
export var priceRow = "styles-module--priceRow--3114f";
export var strikethrough = "styles-module--strikethrough--c6075";
export var strikethroughPrice = "styles-module--strikethroughPrice--102db";